<template>
  <div class="productdata-list">
    <Toolbar :handle-add="() => addHandlerSub('ProductData',product)" v-if="userHasAccess('product_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-purse</v-icon>{{$t('qualitycheck.product.datas')}}</h1>
        </v-flex>
        <v-flex lg12>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandlerSubEvent"
@contextmenu:row="showHandlerSubExt"
          >

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandlerSub(product,'ProductData',props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProductDataList',
  servicePrefix: 'ProductData',
  mixins: [ListMixin,AccessMixin],
  props: {
    product: {
      type: Object,
      required: true
    },
  },
  components: {
    Toolbar,
    ActionCell
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('global.value'), value: 'value' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
      filters: {
        'product' : this.product['@id'],
      },
    };
  },
  computed: {
    ...mapGetters('productdata', {
      items: 'list'
    }),
    ...mapFields('productdata', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('productdata', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    showHandlerSubEvent(value) {
      this.showHandlerSub(this.product,'ProductData',value);
    }
  }
};
</script>
